import { AppDispatch } from "../../../store";
import { fetchCustomers } from "../../../redux/modules/customers/reducer";
import { pushRoute } from "../../../redux/modules/route/actions";
import { generate, ROUTE_SITES } from "../../../redux/modules/route/routes";
import { ensureAclGlobalLevel } from "../../../acl/asyncActions";

export const userOpensCustomersListPage = () => async (
  dispatch: AppDispatch,
): Promise<void> => {
  const customers = await dispatch(fetchCustomers());
  if (customers.length === 1) {
    dispatch(
      pushRoute(
        generate(ROUTE_SITES, {
          customerId: customers[0].id,
        }),
      ),
    );
  } else {
    await dispatch(ensureAclGlobalLevel());
  }
};
